import React from "react";

const URL_SPLIT_REGEX = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;
const URL_TEST_REGEX = /^(https?:\/\/[^\s]+|www\.[^\s]+)$/i;

const LinkifiedText = ({ text }) => {
  if (!text) return null;

  const parts = String(text).split(URL_SPLIT_REGEX);

  return parts.map((part, index) => {
    if (!part) return null;

    if (!URL_TEST_REGEX.test(part)) {
      return <React.Fragment key={index}>{part}</React.Fragment>;
    }

    const href = part.startsWith("http") ? part : `https://${part}`;
    return (
      <a
        key={index}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="message-link"
      >
        {part}
      </a>
    );
  });
};

export default LinkifiedText;
